export default __webpack_public_path__ + "static/media/Nkarrch.2ffa0b86.png";